import { useBrandAccountSurveysQuery } from './useBrandAccountSurveysQuery'

export const useBrandAccountSurveysQueryData = (
  brandAccountId: string | undefined,
) => {
  const result = useBrandAccountSurveysQuery(brandAccountId)

  return result.data ?? []
}
